export default __webpack_public_path__ + "static/media/defi.2a9de270.gif";